

const myPageIndexUserCardInfo = `websitsMember/memberCard`

const myPageIndexGameInfo = `websitsMember/gameInformation`

const about30GameList = `websitsMember/latelyAchievement`

// 我的页面 整体数据
const allGameData = `websitsMember/gameData`;

// Award记录
const awardHistoryData = `websitsMember/awardRecord`;

// 我的页面 账号信息
const accountInfo = `websitsMember/getAccountInfo`;

// 我的页面  账号信息修改
const accountInfoUpdate = 'websitsMember/updateAccountInfo'

// 修改密码
const passwordChange = 'websitsMember/updatePassword'



// 其他设定
// adarts卡信息
const adartsCardList = 'websitsMember/cardList';
// 绑定卡
const adartsBind = 'websitsMember/cardBundling';
// 删除卡
const adartsCardDelete = 'websitsMember/cardUnbundling';
// 设置主卡
const adartsMainCard = 'websitsMember/masterCard';
// 複製卡
const adartsCardCopy = 'websitsMember/copyCard';
// AdartsAward 消息获取
const adartsMegGet = 'websitsMember/getAwardMessage';
// Adarts 信息设定
const adartsMegSet = 'websitsMember/setUpAwardMessage';

// 好友列表
// 近七日对战玩家
const aboutSevenPlayerList = 'friend/warFriends';
// 添加好友
const addFriends = 'friend/addFriend';
// 接受、拒绝好友
const handleFriends = 'friend/agreeFriend';
// 好友列表
const friendsList = 'friend/friendList';
// 星星 好友
const starSetting = 'friend/starFriend';

export {
  myPageIndexUserCardInfo,
  about30GameList,
  myPageIndexGameInfo,
  allGameData,
  awardHistoryData,
  accountInfo,
  passwordChange,
  accountInfoUpdate,
  adartsCardList,
  adartsCardCopy,
  adartsCardDelete,
  adartsBind,
  adartsMainCard,
  adartsMegGet,
  adartsMegSet,
  aboutSevenPlayerList,
  handleFriends,
  friendsList,
  starSetting,
  addFriends
}